import {Component, ChangeDetectionStrategy} from '@angular/core';
import {Dialog} from '../../../../../interfaces/dialog/dialog';
import {DialogParams} from '../../../../../interfaces/dialog/dialog-params';
import {Translation} from '../../../../../types/translation';
import {DialogService} from '../../../../../services/dialog/dialog.service';
import {ConfirmDirective} from '../../../../../directives/confirm/confirm.directive';
import {FormsModule} from '@angular/forms';

import {InputSwitchComponent} from '../../../../layout/input-switch/input-switch.component';

@Component({
  imports: [
    ConfirmDirective,
    FormsModule,
    InputSwitchComponent
],
  templateUrl: './search-replace.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './search-replace.component.scss'
})
export class SearchReplaceComponent implements Dialog {

  search: string = '';
  replace: string = '';
  caseSensitive: boolean = false;

  description: string = '';
  locale: string = '';
  data: Translation[] = [];
  translations: Translation[] = [];

  constructor(private dialog: DialogService) {
  }

  onDialogInit(params: DialogParams): void {
    this.description = params.data.description;
    this.locale = params.data.locale;
    this.data = params.data.data;
  }

  searchAll(): void {
    this.translations = [];

    if (!this.search.trim()) {
      return;
    }

    const flags = this.caseSensitive ? 'g' : 'gi';
    const searchRegex = new RegExp(this.escapeRegExp(this.search), flags);

    for (const translation of this.data) {
      if (searchRegex.test(translation.text)) {
        this.translations.push({
          key: translation.key,
          text: translation.text.replace(searchRegex, this.replace),
        });
      }
    }
  }

  replaceAll(): void {
    this.dialog.closeDialog({
      translations: this.translations,
    });
  }

  private escapeRegExp(str: string): string {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }
}
